<template>
    <v-form v-model="valid" fast-fail @submit.prevent="handleSubmit">
        <UsuarioSelect
            :rolesUsuarios="[8]"
            @usuario-seleccionado="usuarioId = $event">
        </UsuarioSelect>
        <BandejasSelect
            @bandeja-seleccionada="bandejaId = $event">
        </BandejasSelect>
        <v-btn
            type="submit"
            :disabled="!valid"
            id="boton-verde"
            :loading="cargando"
        >
            Asociar
        </v-btn>
    </v-form>
    <AlertComponent
        :title="alertTitle"
        :text="alertText"
        :alertType="alertType"
        :showAlert="showAlert"
        @close="showAlert = false"
    ></AlertComponent>
</template>
<style src="../assets/general.css"></style>
<script>
    import UsuarioSelect from './UsuarioSelect.vue';
    import BandejasSelect from './BandejasSelect.vue';
    import AuthService from '@/api/AuthService';
    import AlertComponent from './AlertComponent.vue';

    const authService = new AuthService();

    export default {
        components: {
            UsuarioSelect,
            BandejasSelect,
            AlertComponent
        },
        data() {
            return {
                usuarioId: null,
                bandejaId: null,
                valid: false,
                cargando: false,
                //datos de alerta
                alertTitle: '',
                alertText: '',
                alertType: '',
                showAlert: false
            }
        },
        methods: {
            async handleSubmit() {
                this.cargando = true;

                const response = await authService.vincularBandejaAutorizador(this.usuarioId, this.bandejaId);
                if (response && response.status === 200) {
                    this.alertTitle = 'Operación exitosa';
                    this.alertText = 'La bandeja ha sido asociada correctamente al usuario.';
                    this.alertType = 'success';
                } else {
                    this.alertTitle = 'Error';
                    this.alertText = response && response.data ? response.data : 'Ha ocurrido un error al asociar la bandeja al usuario.';
                    this.alertType = 'error';
                }
                this.showAlert = true;
                this.cargando = false;
            }
        }
    }
</script>